import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'DesiCart';
  public phone = "83285 79397"
  public title11 = "Hello, What would you like to get from India today?";
}
